import {createRouter, createWebHashHistory} from 'vue-router';
import {getUser} from './main'

const routes = [
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/Dashboard.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/landing_page',
        name: 'landing_page',
        exact: true,
        component: () => import('./pages/LandingPage.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/latitude_request',
        name: 'latitude_request',
        exact: true,
        component: () => import('./components/Latitudes/LatitudeRequest'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/anagrafica_estesa',
        name: 'anagrafica_estesa',
        exact: true,
        component: () => import('./components/Latitudes/AnagraficaEstesa'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/manage_portfolio',
        name: 'manage_portfolio',
        exact: true,
        component: () => import('./components/Latitudes/ManagePortfolio'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/risultato_evasione_richiesta',
        name: 'risultato_evasione_richiesta',
        exact: true,
        component: () => import('./components/Latitudes/RisultatoEvasioneRichiesta'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/massive_upload',
        name: 'massive_upload',
        exact: true,
        component: () => import('./components/Latitudes/MassiveUpload'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/mass_cancel',
        name: 'mass_cancel',
        exact: true,
        component: () => import('./components/Latitudes/MassCancel.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/detail_massive_upload',
        name: 'detail_massive_upload',
        exact: true,
        component: () => import('./components/Latitudes/DetailMassiveUpload'),
        meta: {
            requiresAuth: true
        }
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (getUser() == null || getUser().token == null ) {
            next('/login')
            return
        }
    }
    next()
});

export default router;
